import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const ReplicaDatabaseToAgentHeaderCell = ({
  _customRowProps: { integration },
}: HeaderCellProps) => {
  const { label } = integration;
  return <div>Replica Database to Agent</div>;
};

export default ReplicaDatabaseToAgentHeaderCell;
